import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonHeader, IonInfiniteScroll } from '@ionic/angular';

import { PopUpService } from '../../../shared/components/pop-up/pop-up.service';
import { ArticlesService } from '../../../services/articles.service';
import { ConfigService } from '../../../services/config.service';
import { GaEventTrackerProvider } from '../../../services/gaeventtracker.provider';
import { StorageProvider } from '../../../services/storage.provider';
import { Multitenant } from '../../../services/multitenant.provider';
import { AuthProvider } from '../../../services/auth.provider';
import { MetaProvider } from '../../../services/meta.provider';
import { Logout } from '../../../services/logout.provider';
import { Archive } from '../../../models/archive.model';
import { PopUp } from '../../../models/popup.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { formatDatePublish } from 'src/app/shared/utils';

@Component({
  selector: 'app-archives-list',
  templateUrl: 'archives-list.html',
  styleUrls: ['archives-list.scss']
})
export class ArchivesListPage implements OnInit {

  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  @ViewChild(IonHeader) header: IonHeader;

  public archives: Array<Archive>;
  public error: string;
  public accessToken: string;
  public profileId: string;
  public newspaper: string;
  public first: any = [];
  public themeClass: string;
  public firstArchive: Array<Archive>;
  public isActivePage: string;
  public locale: string;
  public tempPopUp: boolean;
  public popup: PopUp = new PopUp();
  public showSpinner: boolean;
  public iFrameCalameoSrc: SafeResourceUrl;
  public isCalameoModalOpen: boolean;
  private start = 1;
  private offset = 10;
  public currentPosition = window.scrollY;

  constructor(
    private actRoute: ActivatedRoute,
    private router: Router,
    private articlesService: ArticlesService,
    private logout: Logout,
    private auth: AuthProvider,
    private storage: StorageProvider,
    private meta: MetaProvider,
    private ga: GaEventTrackerProvider,
    private multiTenant: Multitenant,
    private popUpService: PopUpService,
    private domSanitization: DomSanitizer,
    public config: ConfigService,
    public renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.showSpinner = true;
    this.isCalameoModalOpen = false;
    if (this.storage.getStorage('access_token')) {
      this.accessToken = this.storage.getStorage('access_token');
    }
    if (this.storage.getStorage('logged_profile_id')) {
      this.profileId = this.storage.getStorage('logged_profile_id');
    }

    this.actRoute.paramMap.subscribe( paramMap => {
      this.newspaper = paramMap.get('newspaper');
      if (this.newspaper) {
        this.getArchives(this.newspaper, this.start, this.offset);
        this.getFirstArchive(this.newspaper, 0, 1);
      }
    });
  }

  ionViewWillEnter() {
    this.isActivePage = 'archives';
    this.themeClass = this.multiTenant.getDomainClass();
    if (this.themeClass === 'mwjp') {
      this.locale = 'ja';
    } else if (this.themeClass === 'week' || this.themeClass === 'mlwk' || this.themeClass === 'mwne' || this.themeClass === 'mlne') {
      this.locale = 'en';
    } else if (this.themeClass === 'sema') {
      this.locale = 'es';
    } else if (this.themeClass === 'woch') {
      this.locale = 'de';
    } else {
      this.locale = 'fr';
    }

    this.renderer.setStyle(this.header['el'], 'webkitTransition', 'margin-top 700ms');
  }

  ionViewDidEnter() {
    this.meta.clearHead();

    if (!this.auth.isAuthenticated() && this.popUpService.havePassedSevenDays() && this.multiTenant.getDomainClass() === 'playbacpresse') {
      this.tempPopUp = true;
      this.popup.type = 'unIdentifiedUser';
    }
  }

  getFirstArchive(newspaper, start, limit) {
    return this.articlesService.getArchivesByNewspaper(newspaper, start, limit).subscribe(
      response => {
        this.showSpinner = false;
        this.firstArchive = response[0];
        this.firstArchive.forEach( ( value: any, index: number, array: any ) => {
          if (value.publish_on) {
            array[index].publishOn = formatDatePublish(value.publish_on);
          }
        });
      },
      error => this.errorFunctionality(error)
    );
  }

  getArchives(newspaper: string, start: number, limit: number) {
    return this.articlesService.getArchivesByNewspaper(newspaper, start, limit).subscribe(
      response => {
        this.showSpinner = false;
        if (!this.archives) {
          this.archives = response[0];
        } else {
          this.archives = this.archives.concat(response[0]);
        }

        this.archives.forEach( ( value: any, index: number, array: any ) => {
          if (value.publish_on) {
            array[index].publishOn = formatDatePublish(value.publish_on);
          }
        });
      },
      error => this.errorFunctionality(error)
    );
  }

  errorFunctionality(error: any) {
    if (error.message === 'Invalid tokens.') {
      this.logout.logOut();
      this.router.navigate(['connexion']);
    }
    this.error = 'Error';
  }

  openPdf(archive: Archive) {
    if (this.auth.isAuthenticated()) {
      this.ga.sendPDFDownloadReader(archive, 'reader');
      const pdfId = archive.pdf_id;
      const newspaperSubname = archive.newspaper_subname;
      const pdfUrl = this.config.getApiDomainByEnv() + '/download?media=' + pdfId + '&entity=newspaperPdf&access_token=' + this.accessToken + '&newspaperSubname=' + newspaperSubname + '&profil=' + this.profileId;
      if (archive.direct_download !== false) {
        window.open(pdfUrl , '_blank');
      } else {
        // get Calameo iFrame url
        this.articlesService.getCalameoUrlForIframe(pdfUrl).subscribe({
          next: (url: { link: string, linkMobile: string }) => {
            this.isCalameoModalOpen = true;
            this.iFrameCalameoSrc = this.domSanitization.bypassSecurityTrustResourceUrl(url.linkMobile ? url.linkMobile : url.link)
          },
          error: (error) => window.open(pdfUrl , '_blank')
        })
      }
    }
  }

  downloadPdf(archive: Archive) {
    this.ga.sendPDFDownloadReader(archive, 'download');
    // const pdfUrl = this.config.getApiDomainByEnv() + '/download?media=' + archive.pdf_id + '&entity=thematicFiles&access_token=' + this.accessToken + '&newspaperSubname=' + archive.newspaper_subname + '&profil=' + this.profileId;
    const pdfUrl = this.config.getApiDomainByEnv() + '/download?media=' + archive.pdf_id + '&entity=newspaperPdf&forcePdf=1&access_token=' + this.accessToken + '&newspaperSubname=' + archive.newspaper_subname + '&profil=' + this.profileId;
    window.open(pdfUrl , '_blank');
  }

  doInfinite(event) {
    this.showSpinner = true;
    this.start = this.start + this.offset;
    if (this.auth.isAuthenticated()) {
      setTimeout(() => {
        this.getArchives(this.newspaper, this.start, this.offset);
        event.target.complete();
      }, 2000);
    }
  }

  public setCalameoOpen(isOpen: boolean) {
    this.isCalameoModalOpen = isOpen;
  }

  public onContentScroll(event:any) {
    let scroll = event.detail.scrollTop;
    if (scroll > 10 && scroll > this.currentPosition) {
      this.renderer.setStyle(this.header['el'], 'margin-top', '-76px');
    } else {
      this.renderer.setStyle(this.header['el'], 'margin-top', '0px');
    }

    this.currentPosition = scroll;
  }
}
